import { useAppProgressLoader } from './useAppProgressLoader';
import { ProgressLoader } from './useProgressLoader';

export const usePromiseProgressLoader = <T>(promise: Promise<T>, progressLoader?: ProgressLoader) => {
	const internalProgressLoader = progressLoader || useAppProgressLoader();

	const perform = (): Promise<T> => {
		const APILoadingSegmentId = internalProgressLoader.start();

		return promise
			.then(
				(result) => {
					internalProgressLoader.finish(APILoadingSegmentId);
					return result;
				},
				(error) => {
					internalProgressLoader.finish(APILoadingSegmentId);
					throw error;
				},
			);
	};

	return {
		perform,
	};
};
